import type { FaireProductEntity } from "../../entity_types/product";

export const p_zw7jcm4vca: FaireProductEntity = {
  token: "p_zw7jcm4vca",
  type: "product",
  name: "Key Lime Salt Water Taffy in Florida Souvenir Bag 6oz.",
  brandName: "Forbes Candies, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/2e044c9e5c1b6867fb704e5473c95270348fa8d47a50408d1a628940f2d9b976.png",
  priceDollars: 2,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/dcae1a078aac9bca808a3828b4903e3cda2f644233b6a17d971d6994216fbcc4.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
